<template lang="pug">
div.main-container(:class="`${this.page} ${this.templateId !== undefined ? this.templateId : ''} ${this.classes !== undefined ? this.classes : ''}`")
  navigation
  main.page.landing

    //- main page info section
    section#opening.row(v-if="this.title || this.desc || this.image")
      .page-header
        h1(v-if="this.title")
          vue-markdown(:source='this.title')
        vue-markdown.desc(:source='this.desc' v-if="this.desc")
      div.hero(v-if="this.image")
        img(:src='this.image && this.image.fields.file.url' :alt='this.image && this.image.fields.file.fileName')

    //- child sections
    section(v-for="(n, i) in this.sections" :id="`section-${n.fields.templateId}-${n.sys.id}`" :class="`row ${n.fields.templateId} ${n.fields.classes && n.fields.classes.join(' ')}`")
      component(:id="`${n.fields.templateId}-${n.sys.id}`" :is="kebabToCamel(n.fields.templateId)" :payload="n" :key="n.sys.id")

  pageFooter(v-if="this.pageFooter" :domainInfo="this.appData.root.fields" :payload="this.pageFooter")
</template>

<script>
import pageBase from '@/scenes/_pageBase.js'

export default {
  name: 'PageScene',
  mixins: [pageBase],
  components: {},
  data: function () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  }
}

</script>

<style lang="scss">
.article {
  img{
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/scenes/pageScene.vue